/*
 * @Author: zjw
 * @Date: 2021-06-30 14:20:03
 * @LastEditTime: 2021-06-30 14:22:06
 * @FilePath: \web-app\src\common\common.js
 * @Environment: Vue + Element
 * @Description: 定义全局函数
 */
export default {
    /**
     * 时间戳转日期
     * @param {*} timestamp  时间戳
     */
    _timestampToTime(timestamp, flag = false) {
        let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '年'
        let M =
            (date.getMonth() + 1 < 10 ?
                '0' + (date.getMonth() + 1) :
                date.getMonth() + 1) + '月'
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日'
        let h =
            (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
            ':'
        let m =
            (date.getMinutes() < 10 ?
                '0' + date.getMinutes() :
                date.getMinutes()) + ':'
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        if (flag) {
            return Y + M + D
        } else {
            return Y + M + D + h + m + s
        }
    },

    /**
     * 时间戳转年月日
     */
    _timeStampToYearDay(stamp, type = 0) {
        let date = new Date(stamp)
        return `${date.getFullYear()}年${date.getMonth() +
            1}月${date.getDate()}日 ${
            date.getHours().toString().length == 1
                ? '0' + date.getHours()
                : date.getHours()
        }:${
            date.getMinutes().toString().length == 1
                ? '0' + date.getMinutes()
                : date.getMinutes()
        }:${
            date.getSeconds().toString().length == 1
                ? '0' + date.getSeconds()
                : date.getSeconds()
        }`
    },

    //获取当前时间
    _getNowTime() {
        return (
            new Date().getFullYear() +
            '-' +
            (new Date().getMonth() + 1 < 10 ?
                '0' + (new Date().getMonth() + 1) :
                new Date().getMonth() + 1) +
            '-' +
			(new Date().getDate() < 10 ?
			    '0' + new Date().getDate() :
			    new Date().getDate()) +
            ' ' +
			(new Date().getHours() < 10 ?
			    '0' + new Date().getHours() :
			    new Date().getHours()) +
            ':' +
            (new Date().getMinutes() < 10 ?
                '0' + new Date().getMinutes() :
                new Date().getMinutes()) +
            ':' +
            (new Date().getSeconds() < 10 ?
                '0' + new Date().getSeconds() :
                new Date().getSeconds())
        )
    },

    /**
     * 存储localStorage
     */
    _setStore(name, content) {
        if (!name) return
        if (typeof content !== 'string') {
            content = JSON.stringify(content)
        }
        localStorage.setItem(name, content)
    },

    /**
     * 获取localStorage
     */
    _getStore(name) {
        if (!name) return
        return localStorage.getItem(name)
    },

    /**
     * 删除localStorage
     */
    _removeStore(name) {
        if (!name) return
        localStorage.removeItem(name)
    },

    /**
     * 清空localStorage
     */
    _clearStore() {
        localStorage.clear()
    },

    /**
     * 格式化金钱
     */
    _thousandNum(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * 生成随机ID
     */
    _randomId(len) {
        return Math.random()
            .toString(36)
            .substr(3, len)
    },

    /**
     * 生成范围随机数
     */
    _randomNum(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
    },

    /**
     * 判断数据类型
     * _dataType({}, "array"); // false
     * _dataType([], "array"); // true
     */
    _dataType(tgt, type) {
        const dataType = Object.prototype.toString
            .call(tgt)
            .replace(/\[object (\w+)\]/, '$1')
            .toLowerCase()
        return type ? dataType === type : dataType
    },

    /**
     * 是否为空数组
     */
    _isEmptyArr(arr) {
        return Array.isArray(arr) && !arr.length
    },

    /**
     * 是否为空对象
     */
    _isEmptyObj(obj) {
        return this._dataType(obj, 'object') && !Object.keys(obj).length
    },

    /**
     * 过滤数组中空值
     * 空值：undefined、null、""、0、false、NaN
     */
    _filterArr(arr) {
        return arr.filter(Boolean)
    },

    /**
     * 验证url是否正确，true/false
     */
    _isUrl(url) {
        return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/i.test(
            url
        )
    },

    /**
     * 验证手机号码是否正确， true/false
     */
    isTel(tel) {
        return /^1[3|4|5|8][0-9]\d{4,8}$/.test(tel)
    },

    /**
     * 过滤XSS
     */
    _filterXss(content) {
        let elem = document.createElement('div')
        elem.innerText = content
        const result = elem.innerHTML
        elem = null
        return result
    },
}